module.exports = __webpack_public_path__ + "img/Visible-patient.2d094242.png";